import React, { memo } from 'react';
import { marcasLogos } from '../../../data/patiosData';
import MarcaBreakdownItem from './MarcaBreakdownItem';

const BRANDS_PER_PAGE = 4;

const MarcaCarousel = memo(({
  sortedMarcasEntries,
  totalPages,
  currentPage,
  isAlertCard,
  detailedMarcasData,
  variant = 'compact',
}) => {
  const isExpanded = variant === 'expanded';
  const gapCls = isExpanded ? 'gap-x-4 gap-y-1' : 'gap-x-2 gap-y-0.5';

  return (
    <div className="overflow-hidden">
      <div
        data-testid="carousel-strip"
        style={{
          display: 'flex',
          transform: `translateX(-${currentPage * 100}%)`,
          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {Array.from({ length: totalPages }).map((_, pageIdx) => {
          const pageBrands = sortedMarcasEntries.slice(
            pageIdx * BRANDS_PER_PAGE,
            (pageIdx + 1) * BRANDS_PER_PAGE
          );
          return (
            <div key={pageIdx} style={{ minWidth: '100%' }}>
              <div className={`grid grid-cols-2 ${gapCls}`}>
                {pageBrands.map(([marca, cantidad]) => {
                  if (isExpanded) {
                    const brandDetails = detailedMarcasData?.find(m => m.marca === marca);
                    return (
                      <MarcaBreakdownItem
                        key={marca}
                        marca={marca}
                        cantidad={cantidad}
                        isAlertCard={isAlertCard}
                        tooltipData={brandDetails}
                      />
                    );
                  }
                  return (
                    <div key={marca} className="flex items-center justify-between text-[12.65px]">
                      <div className="flex items-center min-w-0 flex-1">
                        {marcasLogos[marca] && (
                          <img src={marcasLogos[marca]} alt={marca} className="w-3 h-3 object-contain mr-1 flex-shrink-0" onError={(e) => { e.target.style.display='none'; }} />
                        )}
                        <span className={`truncate ${isAlertCard ? 'text-white' : 'text-gray-600'}`}>
                          {marca}
                        </span>
                      </div>
                      <span className={`font-semibold ml-1 ${isAlertCard ? 'text-white' : 'text-gray-900'}`}>
                        {cantidad}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

MarcaCarousel.displayName = 'MarcaCarousel';
export default MarcaCarousel;
